import React, { useEffect, useState } from 'react';
import { Bell, Volume2, VolumeX } from 'lucide-react';
import { isMuted, onAlertChange, setMuted, unlockAudio, audioUnlocked } from '../lib/chime';

// Visual new-order indicator. The sound itself is global (see components/SoundGate + AppContext).
const AlertBell = ({ count = 0, onOpen, label = 'pedidos nuevos', compact = false }) => {
  const [muted, setMutedState] = useState(isMuted());
  const [unlocked, setUnlocked] = useState(audioUnlocked());
  const [ringing, setRinging] = useState(false);
  const prev = React.useRef(count);

  useEffect(() => onAlertChange((s) => { setMutedState(s.muted); setUnlocked(s.unlocked); }), []);
  useEffect(() => {
    if (count > prev.current) setRinging(true);
    if (count === 0) setRinging(false);
    prev.current = count;
  }, [count]);

  const toggleMute = async () => {
    const next = !muted;
    setMuted(next);
    setMutedState(next);
    if (!next) setUnlocked(await unlockAudio());
  };

  const open = () => { setRinging(false); onOpen?.(); };

  return (
    <div className="flex items-center gap-1.5" data-testid="alert-bell">
      {ringing && !compact && (
        <span data-testid="alert-banner" className="hidden sm:flex items-center gap-1.5 text-xs font-bold text-[#EE3B36] bg-[#FDECEC] px-2.5 py-1 rounded-full animate-pulse">
          {count} {label}
        </span>
      )}
      <button
        data-testid="alert-open"
        onClick={open}
        aria-label="Notificaciones"
        className={`relative p-2 rounded-xl transition-colors ${ringing ? 'bg-[#FDECEC] text-[#EE3B36]' : 'hover:bg-white text-[#1E2130]'}`}
      >
        <Bell size={22} className={ringing ? 'animate-bounce' : ''} />
        {count > 0 && <span className="absolute -top-0.5 -right-0.5 bg-[#EE3B36] text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">{count > 9 ? '9+' : count}</span>}
      </button>
      <button
        data-testid="alert-mute"
        onClick={toggleMute}
        aria-label={muted ? 'Activar sonido' : 'Silenciar sonido'}
        title={muted ? 'Activar sonido' : 'Silenciar sonido'}
        className={`p-2 rounded-xl transition-colors ${muted ? 'text-gray-400 hover:bg-white' : 'text-emerald-600 hover:bg-white'}`}
      >
        {muted ? <VolumeX size={20} /> : <Volume2 size={20} />}
      </button>
      {!muted && !unlocked && (
        <button data-testid="alert-enable-sound" onClick={async () => setUnlocked(await unlockAudio())} className="text-[11px] font-bold text-[#EE3B36] bg-[#FDECEC] px-2 py-1 rounded-full whitespace-nowrap">
          Activar sonido
        </button>
      )}
    </div>
  );
};

export default AlertBell;
